import React from 'react'
import PropTypes from 'prop-types'

import Field from 'components/_new/forms/Field/Field'

import messages from './messages'
import s from './PasswordField.scss'


// TODO remove className, add "icon" prop to StandardInputView
const PasswordField = ({ field, standardView, onBlur, autoComplete }) => {
  const props = {
    className: standardView ? s.withLockIcon : undefined,
    [standardView ? 'placeholder' : 'label']: messages.label,
    standardView,
  }

  return (
    <Field
      id="passwordRegister"
      field={field}
      type="password"
      onBlur={onBlur}
      autoComplete={autoComplete}
      {...props}
    />
  )
}

PasswordField.propTypes = {
  field: PropTypes.object,
  onBlur: PropTypes.func,
  standardView: PropTypes.bool,
  autoComplete: PropTypes.string,
}


export default PasswordField
